var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Wrapper, Lists } from "./components";
// import {ListBoardProps} from "./types";
import { ListBoardList } from "./list";
import { RotateLoader } from "../loaders/rotate";
let ListBoard = class ListBoard extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        const { data, columns, renderIcon, renderRow, renderRowDropdown } = this.props;
        const { error, loading } = data;
        if (error) {
            return React.createElement("p", { className: "error-text" }, "Something went wrong, refresh the page and try again");
        }
        if (loading) {
            return React.createElement(RotateLoader, { size: 4 });
        }
        return (React.createElement(Wrapper, null, columns.map((column, i) => {
            if (column.lists.length === 1 && column.lists[0].hide) {
                return null;
            }
            return (React.createElement(Lists, { key: i }, column.lists.map((list, k) => {
                return (React.createElement(ListBoardList, { key: k, data: data, list: list, renderIcon: renderIcon, renderRow: renderRow, renderRowDropdown: renderRowDropdown }));
            })));
        })));
    }
};
ListBoard = __decorate([
    observer
], ListBoard);
export { ListBoard };
//# sourceMappingURL=index.js.map